import { FC, FormEvent, MouseEvent, useEffect, useRef, useState } from "react"
import { NoProps } from "../../shared/types"
import { Logger } from "../../shared/Logger"
import { getThreads, ThreadSummary, ThreadData, getThread, Post, postToThread, getPreviewOfPost } from "../../services/BoardData"
import { NavLink, useLocation, useParams } from "react-router-dom"
import Markdown from "react-markdown"
import SubmitButton from "../../widgets/ButtonSubmit"
import NavlinkOutline from "../../widgets/NavlinkOutline"

type ThreadProps = {
    threadId: string
}

type State = {
    thread?: ThreadData
    threadId: string
    wasPreviewPost: boolean
}

const NewThread: FC<NoProps> = () => {
    const params = useParams()
    const [state, setState] = useState({ threadId: params['threadId'], wasPreviewPost: false } as State)
    Logger.info(`thread render - ${JSON.stringify(location)} ${JSON.stringify(state)} `)
    useEffect(() => {
        getThread({ threadId: state.threadId }).then(thread => setState({ ...state, thread }))
    }, [getThreads, state.threadId])

    const textEntryField = useRef<HTMLInputElement>(null)

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const handlePostClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault()
        const body = textEntryField?.current?.value || ''
        postToThread({ threadId: state.threadId, body }).then(thread => {
            setState({ ...state, thread, wasPreviewPost: false })
        })

        textEntryField.current && (textEntryField.current.value = '')
    }

    const handlePreviewClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault()
        const body = textEntryField?.current?.value || ''
        getPreviewOfPost({ threadId: state.threadId, body }).then(thread => {
            setState({ ...state, thread, wasPreviewPost: true })
        })
    }

    return (
        <div className="container mx-auto">
            {<div>
                <h1>awwwww yeah, a new thread, cool</h1>
                <div className="w-full flex">
                    <form className="p-2 pb-0 w-full flex" onSubmit={handleSubmit}>
                        <input
                            className="mt-3 flex-grow max-w-96"
                            type="text"
                            placeholder="what's on your mind, friend?"
                            id="customTextField"
                            ref={textEntryField}
                        />
                    </form>
                </div>
                <div className="pt-10 ">
                    <NavlinkOutline toPath="/board" linkText="back to the shit..." />
                    <SubmitButton clickHandler={handlePostClick} buttonText="post" />
                    <SubmitButton clickHandler={handlePreviewClick} buttonText="preview" />
                </div>
            </div>}
        </div>
    )
}

export default NewThread